import { useFlag } from '@unleash/proxy-client-vue';
import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import { ColumnSpecification } from '@rygen/rygen-ui/model';

/**
 * Keys of the origin/destination location group columns. Both the database and
 * the elasticsearch column specifications share these keys.
 */
const LOCATION_GROUP_COLUMN_KEYS = [
  'originLocationGroups',
  'destinationLocationGroups',
];

export interface UseLocationGroupingResponse {
  isLocationGroupingEnabled: ComputedRef<boolean>;
  /**
   * Removes the location group columns when location grouping is disabled
   */
  filterLocationGroupColumns: (
    columns: ColumnSpecification[],
  ) => ColumnSpecification[];
}

export const useLocationGrouping = (): UseLocationGroupingResponse => {
  const _isLocationGroupingEnabled = useFlag('location-grouping-feat-flag');

  const isLocationGroupingEnabled = computed(
    () => _isLocationGroupingEnabled.value,
  );

  const filterLocationGroupColumns = (
    columns: ColumnSpecification[],
  ): ColumnSpecification[] => {
    if (isLocationGroupingEnabled.value) {
      return columns;
    }

    return columns.filter(
      (col) => !LOCATION_GROUP_COLUMN_KEYS.includes(col.key),
    );
  };

  return {
    isLocationGroupingEnabled,
    filterLocationGroupColumns,
  };
};
